import { useCallback } from "react";
import { useAnalyticSession } from "./AnalyticsSessionProvider";

export function useAnonymizeEventProperty() {
    const session = useAnalyticSession();
    return useCallback((propertyValue: string) => session.anonymize(propertyValue), [session]);
}
